// 主题
import "codemirror/theme/ambiance.css"
import "codemirror/theme/blackboard.css"
import "codemirror/theme/bespin.css"
import "codemirror/theme/cobalt.css"
import "codemirror/theme/colorforth.css"
import "codemirror/theme/darcula.css"
import "codemirror/theme/dracula.css"
import "codemirror/theme/elegant.css"
import "codemirror/theme/eclipse.css"
import "codemirror/theme/hopscotch.css"
import "codemirror/theme/idea.css"
import "codemirror/theme/material.css"

import "codemirror/addon/edit/matchbrackets"
import "codemirror/addon/comment/comment"
import "codemirror/addon/comment/continuecomment"
import "codemirror/addon/selection/active-line"

export default [
    "material",
    "ambiance",
    "blackboard",
    "bespin",
    "cobalt",
    "colorforth",
    "darcula",
    "dracula",
    "elegant",
    "eclipse",
    "hopscotch",
    "idea"
];